import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { FormPayloadI } from 'src/app/types';
import { ActivatedRoute, Router } from '@angular/router';
import { DataEntryConfiguraion } from '../../../../types/response-data.component';
import { FormBuilderComponent } from '../../../../components/form-buider/form-buider.component';
import { FormControl } from '@angular/forms';
import { DataManagementAppService } from 'src/app/services/data-management-app.service';
@Component({
  selector: 'app-data-pull-configuration',
  template: `
    <div class="dpc-page">
      <div
        *ngIf="!waiting"
        class="fixed inset-0 flex justify-center items-center z-50 mt-10"
      >
        <mat-spinner></mat-spinner>
      </div>

      <div *ngIf="waiting">
        <div class="namebar" *ngIf="!readyToConfigure">
          <mat-form-field class="example-full-width">
            <mat-label>Enter DataSource Name</mat-label>
            <input matInput [(ngModel)]="dataSourceName" />
          </mat-form-field>
          <button
            class="btn-primary"
            (click)="setDataSourceName()"
          >
            Proceed
          </button>
        </div>

        <div class="pull-cols" *ngIf="readyToConfigure">
          <div
            class="pull-col"
            *ngFor="let connectionObject of dataConfiguration; index as i"
          >
            <h3>{{ connectionObject['headerLabel'] }}</h3>

            <mat-form-field class="dpc-field">
              <mat-label
                attr.for="{{ connectionObject['connectionBtnName'] }}"
                >{{ connectionObject['connectionBtnName'] }}</mat-label
              >
              <mat-select
                id="{{ connectionObject['connectionName'] }}"
                (ngModelChange)="setConnectionType(i)"
                [formControl]="dataConfiguration[i].option_value"
              >
                <mat-option
                  *ngFor="
                    let option_value of connectionObject['connectionsList']
                  "
                  [value]="option_value['connection_name']"
                  >{{ option_value['connection_name'] }}</mat-option
                >
              </mat-select>
            </mat-form-field>

            <ng-container *ngIf="payloadConfiguration[i]['optionFlag']">
              <mat-form-field class="dpc-field">
                <mat-label for="obj['name']">
                  {{ payloadConfiguration[i]['name'] }}</mat-label
                >
                <mat-select
                  [id]="payloadConfiguration[i]['title']"
                  (ngModelChange)="setPayload(i)"
                  [formControl]="payloadConfiguration[i]['optionValue']"
                >
                  <mat-option
                    *ngFor="
                      let entity of payloadConfiguration[i]['allPayloads']
                        | keyvalue
                    "
                    [value]="entity.key"
                    >{{ entity.key }}</mat-option
                  >
                </mat-select>
              </mat-form-field>

              <div class="formcard" *ngIf="payloadConfiguration[i]['payloadFlag']">
                <div class="ttl">Pull parameters</div>
                <app-form-buider
                  #formBuilder
                  [FormPayload]="payloadConfiguration[i]['payload']"
                  [Output]="payloadConfiguration[i]['outputData']"
                  (dataEvent)="getOutput($event, i)"
                  [fieldWidthInRem]="20"
                ></app-form-buider>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="dpc-foot" *ngIf="readyToConfigure">
      <button
        class="btn-primary"
        (click)="submitData()"
        [disabled]="
          !payloadConfiguration[0]['payloadFlag'] &&
          !payloadConfiguration[1]['payloadFlag']
        "
      >
        Continue
        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </button>
    </div>
  `,
  styleUrls: ['./data-pull-configuration.component.scss'],
})
export class DataPullConfigurationComponent implements OnInit {
  @ViewChildren('formBuilder') payloadForms?: QueryList<FormBuilderComponent>;
  @Output() dataChanged = new EventEmitter<number>();
  waiting: boolean = true;
  dataSourceName: string | any = '';
  readyToConfigure: boolean = false;
  dataConfiguration = [
    {
      connectionName: 'source_connection',
      connectionBtnName: 'Source Connection',
      option_value: new FormControl('1: postgresql'),
      headerLabel: 'Setup Raw Data Source',
      connectionsList: [],
    },
    {
      connectionName: 'destination_connection',
      connectionBtnName: 'Destination Connection',
      option_value: new FormControl('1: postgresql'),
      headerLabel: 'Setup Output Destination',
      connectionsList: [],
    },
  ];
  payloads: FormPayloadI = {
    title: 'test',
    fields: [],
  };
  allpayloads: { [key: string]: FormPayloadI } = {
    test: this.payloads,
  };

  payloadConfiguration: { [key: string]: any }[] = [
    {
      optionFlag: false,
      title: 'Type',
      name: 'Type',
      optionValue: new FormControl(''),
      payloadFlag: false,
      allPayloads: {},
      payload: {},
      outputData: '',
    },
    {
      optionFlag: false,
      title: 'Type',
      name: 'Type',
      optionValue: new FormControl(''),
      payloadFlag: false,
      allPayloads: null,
      payload: null,
      outputData: '',
    },
  ];

  outPutFormat: DataEntryConfiguraion = {
    source_PayloadType: '',
    destination_PayloadType: '',
    source_id: 0,
    source_conf: {
      type: 'pandas.SQLTableDataset',
      table_name: 'quota',
      load_args: {},
      save_args: {},
    },
    destination_id: 1,
    destination_conf: {
      type: 'pandas.SQLTableDataset',
      table_name: 'source_quota',
      load_args: {},
      save_args: {},
    },
    extra_info: {},
    category: 'default',
  };

  next: boolean = true;

  options = [{ type: 'is_source' }, { type: 'is_destination' }];

  availableDataSources: any = [];

  constructor(
    private dataManagementServices: DataManagementAppService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: SharedFeaturesService
  ) {}
  async ngOnInit() {
    this.dataSourceName = this.route.snapshot.paramMap.get('data_name');
    this.waiting = true;
    for (let i = 0; i < this.options.length; i++) {
      this.dataManagementServices
        .getConnections(this.options[i].type)
        .subscribe((result: any) => {
          this.dataConfiguration[i]['connectionsList'] = result;
        });
    }
    let result: any = {};
    if (this.dataSourceName && this.dataSourceName != 'Configure DataSet')
      result = await this.dataManagementServices.getDataManagemententry1(
        this.dataSourceName
      );
    if ('id' in result) {
      this.dataSourceName = result.data_name;
      this.readyToConfigure = true;
      this.snackBar.openSnackBar(
        'You have already configured this data set.',
        'Close',
        'success-snackbar'
      );
      this.next = false;
      this.outPutFormat = this.removeExtraKeys(this.outPutFormat, result);
      for (let i = 0; i < 2; i++) {
        let connectionObj = this.dataConfiguration[i]['connectionsList'].filter(
          (x: any) => {
            if (i == 0) {
              if (x['id'] == this.outPutFormat.source_id) {
                return x;
              }
            } else {
              if (x['id'] == this.outPutFormat.destination_id) {
                return x;
              }
            }
          }
        );
        this.dataConfiguration[i]['option_value'] = new FormControl(
          connectionObj[0]['connection_name']
        );
        await this.setConnectionType(i);
        if (i == 0) {
          this.payloadConfiguration[i]['optionValue'] = new FormControl(
            this.outPutFormat.source_PayloadType
          );
          this.payloadConfiguration[i]['outputData'] =
            this.outPutFormat.source_conf;
        } else {
          this.payloadConfiguration[i]['optionValue'] = new FormControl(
            this.outPutFormat.destination_PayloadType
          );
          this.payloadConfiguration[i]['outputData'] =
            this.outPutFormat.destination_conf;
        }
        this.setPayload(i);
      }
      this.dataManagementServices.setDestinationTableName(
        result['destination_conf']['table_name']
      );
    } else {
      if (this.dataSourceName && this.dataSourceName != 'Configure DataSet') {
        this.readyToConfigure = true;
      }
      this.dataSourceName =
        this.dataSourceName == 'Configure DataSet' ? '' : this.dataSourceName;
      this.snackBar.openSnackBar(
        'Please configure the connection of data to proceed.',
        'Close',
        'success-snackbar'
      );
    }

    this.dataManagementServices.getConfiguredDataSource().subscribe({
      next: (response: any) => {
        this.availableDataSources = response.map((obj: any) => obj.data_name);
      },
    });
  }

  async setConnectionType(index: number) {
    let value = this.dataConfiguration[index]['option_value'].value;
    this.payloadConfiguration[index]['optionFlag'] = true;
    let connection = this.dataConfiguration[index]['connectionsList'].filter(
      (x: any) => x['connection_name'] === value
    );
    let connectionType = connection.map((x: any) => x['connection_type_id']);
    if (index == 0) {
      this.outPutFormat.source_id = connection[0]['id'];
    } else {
      this.outPutFormat.destination_id = connection[0]['id'];
    }
    let temp = await this.dataManagementServices.getConnectionTemplate(
      connectionType[0]
    );
    this.payloadConfiguration[index]['allPayloads'] = this.filterTemplate(
      index,
      temp
    );
  }

  filterTemplate(index: number, data: any) {
    // checking if it is destination
    if (index != 0) {
      const { table } = data; // add more keys which you want to display in destination
      const newObj = { table };
      for (let i = 0; i < newObj.table.fields.length; i++) {
        if (newObj.table.fields[i].key == 'table_name') {
          newObj.table.fields[i] = {
            key: 'table_name',
            hidden: true,
            default: this.dataSourceName,
            editable: false,
          };
        }
      }
      return newObj;
    }
    return data;
  }
  setPayload(index: number) {
    let payloadType = this.payloadConfiguration[index]['optionValue'].value;
    this.payloadConfiguration[index]['payloadFlag'] = false;
    (this.payloadConfiguration[index] as { payload: any }).payload = null;
    let temp = this.payloadConfiguration[index]['allPayloads'][payloadType];
    if (index === 0) {
      if (this.outPutFormat.source_PayloadType != payloadType)
        this.payloadConfiguration[index]['outputData'] = {};
      this.outPutFormat.source_PayloadType = payloadType;
    } else {
      if (this.outPutFormat.destination_PayloadType != payloadType)
        this.payloadConfiguration[index]['outputData'] = {};
      this.outPutFormat.destination_PayloadType = payloadType;
    }
    this.payloadConfiguration[index]['payload'] = temp;

    this.payloadConfiguration[index]['payloadFlag'] = true;
  }

  getOutput(data: any, index: number) {
    this.payloadConfiguration[index]['outputData'] = data;
  }

  removeExtraKeys(data1: object, data2: any): any {
    const keys1 = Object.keys(data1);
    const keys2 = Object.keys(data2);
    const filteredKeys2 = keys2.filter((key) => keys1.includes(key));
    return filteredKeys2.reduce((obj: any, key: string) => {
      obj[key] = data2[key];
      return obj;
    }, {});
  }

  setDataSourceName() {
    this.dataSourceName = this.dataSourceName.trim().toLowerCase();
    if (this.availableDataSources.includes(this.dataSourceName)) {
      this.snackBar.openSnackBar(
        'data-source name already exist',
        'Close',
        'error-snackbar'
      );

      return;
    }
    if (this.dataSourceName.trim().toLowerCase() == '') {
      this.snackBar.openSnackBar(
        'invalid datasource name',
        'Close',
        'error-snackbar'
      );
    } else {
      this.readyToConfigure = true;
    }

    this.router.navigate(['../', this.dataSourceName], {
      relativeTo: this.route,
    });
  }

  submitData() {
    this.payloadForms?.map((form) => form.generateOutput());
    this.outPutFormat.source_conf = this.payloadConfiguration[0]['outputData'];
    this.outPutFormat.destination_conf =
      this.payloadConfiguration[1]['outputData'];
    this.outPutFormat.category = this.dataManagementServices.getDataSetType();
    this.dataManagementServices
      .putDataManagemententry(this.outPutFormat, this.dataSourceName)
      .subscribe(
        (result) => {
          this.next = false;
          this.runPipeline();
        },
        (error) => {
          this.snackBar.openSnackBar(error['msg'], 'Close', 'error-snackbar');
        }
      );
  }

  runPipeline() {
    (async () => {
      this.waiting = false;
      const result = await this.dataManagementServices.generateData(
        this.dataSourceName,
        'dm_initial'
      );
      setTimeout(() => {
        if ('error' in result) {
          this.waiting = true;
          this.snackBar.openSnackBar(result.error, 'Close', 'error-snackbar');
        } else {
          this.snackBar.openSnackBar(
            'Configuration Succesfully Saved',
            'Close',
            'success-snackbar'
          );
          this.dataChanged.emit(1);
          this.router.navigate(['../../data_preview', this.dataSourceName], {
            relativeTo: this.route,
          });
        }
      }, 5000);
    })();
  }
}
